import React, { useState } from "react";
import * as Yup from "yup";
import { Field, FieldArray, Form, Formik } from "formik";
import { Modal, ModalBody } from "react-bootstrap";
import "../modal.css";
import { useDispatch } from "react-redux";
import SuccessPopup from "../../popups/SuccessPopup";
import ErrorPopup from "../../popups/ErrorPopup";
import { useNavigate } from "react-router-dom";
import InputField from "../../form/inputField/inputField";
import {
  productBatchPricingDropDown,
  rejectPendingInvoiceDetail,
} from "../../../redux/actions/invoiceVerificationAction";

const ReuploadInvoiceModal = ({ show, handleClose, verification_json, id }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState();
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState();

  const initialValues = {
    reasons: [],
    new_reason: "",
  };

  const validationSchema = Yup.object()
    .shape({
      reasons: Yup.array(),
      new_reason: Yup.string(),
    })
    .test(
      "at-least-one-reason",
      "At least one reason must be provided",
      function (values) {
        const { reasons = [], new_reason = "" } = values;
        return reasons.length > 0 || new_reason.trim() !== "";
      }
    );

  const onSubmit = (values) => {
    let finalReasons = [...values.reasons];
    if (values.new_reason.trim()) {
      finalReasons.push(values.new_reason.trim());
    }

    console.log(finalReasons, "finalReasons");
    dispatch(
      rejectPendingInvoiceDetail(
        {
          id: id,
          verification_json: verification_json,
          rejection_reason: finalReasons.join(" , "),
        },
        onSuccess,
        onError
      )
    );
  };

  const timeOutFnc = () => {
    setShowSuccessPopup(false);
    navigate("/invoice-verification/pending-invoices");
  };

  const onSuccess = (data) => {
    console.log(data);
    handleClose();
    setShowSuccessPopup(true);
    const str = data.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowSuccessMsg(str_modify);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    console.log(err);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
    setTimeout(() => {
      setShowErrorPopup(false);
    }, 2500);
  };

  const reasonsList = [
    { label: "Mistake Quantity", value: "Mistake Quantity" },
    { label: "Mistake Price", value: "Mistake Price" },
    { label: "PTR not updated", value: "PTR not updated" },
    {
      label: "Distributor Details Mismatched",
      value: "Distributor Details Mismatched",
    },
    {
      label: "Customer Details Mismatched",
      value: "Customer Details Mismatched",
    },
    {
      label: "Order Details Mismatched",
      value: "Order Details Mismatched",
    },
  ];

  return (
    <>
      <Modal
        centered
        show={show}
        onHide={handleClose}
        dialogClassName=""
        contentClassName="link-modal col-5 mx-auto p-2 fn_Nunito"
      >
        <ModalBody>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            enableReinitialize={true}
          >
            {({ setFieldValue, values }) => (
              <Form className="p-1">
                <p className="fn_Nunito fw_700 fs_18 my-2 px-0">
                  Resend Invoice - Please specify reason
                </p>

                <div>
                  <div className="my-3">
                    <FieldArray name="reasons">
                      {({ push, remove, form }) =>
                        reasonsList.map((ele, index) => {
                          const isChecked = form.values.reasons.includes(
                            ele.value
                          );
                          return (
                            <div
                              className="d-flex my-1 align-items-center justify-content-start"
                              key={index}
                            >
                              <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={() => {
                                  if (isChecked) {
                                    const idx = form.values.reasons.indexOf(
                                      ele.value
                                    );
                                    remove(idx);
                                  } else {
                                    push(ele.value);
                                  }
                                }}
                                className="superCheck mb-2"
                              />
                              <label className="fs_16 mx-2 pt-1">
                                {ele.label}
                              </label>
                            </div>
                          );
                        })
                      }
                    </FieldArray>
                  </div>
                  <InputField
                    id={"new_reason"}
                    name={"new_reason"}
                    label={"If not above please specify reason"}
                    labelColor={"color_262c3d"}
                    type={"text"}
                    placeholder={"Enter Reason"}
                    value={values.new_reason}
                  />
                </div>

                <div className="d-flex justify-content-end align-items-center gap-3">
                  <button
                    type="button"
                    onClick={() => handleClose()}
                    className="modal-logout-btn fs_14 fw_700 px-4 py-2"
                    style={{ width: "130px" }}
                  >
                    NO
                  </button>
                  <button
                    type="submit"
                    className="modal-cancel-btn fs_14 text-white py-2 px-4 fw_700"
                    style={{ width: "130px" }}
                  >
                    Send
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </ModalBody>
      </Modal>
      <SuccessPopup show={showSuccessPopup} title={showSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
    </>
  );
};

export default ReuploadInvoiceModal;
